import React from 'react';
import { Box, BoxProps } from '@material-ui/core';
import styled from 'styled-components';

export const ClickableBox = styled((props: BoxProps) => <Box {...props} />)`
    ${({ onClick }) => `
        ${onClick
        ? `
            :hover {
                cursor: pointer;
            }
            `
        : null}
    `}
`;